import { render, staticRenderFns } from "./ChatManage.vue?vue&type=template&id=52c357cb&scoped=true&"
import script from "./ChatManage.vue?vue&type=script&lang=js&"
export * from "./ChatManage.vue?vue&type=script&lang=js&"
import style0 from "./ChatManage.vue?vue&type=style&index=0&id=52c357cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c357cb",
  null
  
)

export default component.exports